import React from 'react'
import { InstallationsApiView } from 'src/Libs/installations/components/InstallationsApiView'
import { allInstallationsFetchProps } from 'src/Libs/installations/utils/installation-table-columns'

/**
 * Component in to display the standard installations in the overview
 */
const StandardInstallations: React.FC = () => {
  return <InstallationsApiView keyValue={4} fetchProps={allInstallationsFetchProps} dataQaPrefix={'installations-incomplete'} />
}

export default StandardInstallations
